import { AxiosResponse } from "axios";
import { API_URL } from "../constants/url-config";
import { AllOnboardingModel, InviteUserModel } from "../models/onboarding/onboarding";
import { deleteAsync, getAsync, postAsync, putAsync, uploadFileAsync } from "../utils/http-client";



const serviceUrl = API_URL.clientService;

const API_PATH = {
    resources: "/resources",
    appraisal: "/appraisal-tool",
    benefitTypes: "/breakdown-funding-and-benefit-types",
    inviteUser: "/onboarding/invite-user/",
    generalOnboarding: "/onboarding/general/",
    downloadSampleConfigFile: "/onboarding/ecap-leader/config-files/samples",
    uploadConfigFile: "/onboarding/ecap-leader/upload-config-file",
    configFiles: "/onboarding/ecap-leader/config-files/",
    users: "/users/",
    clientInfo: "/client/info/"
}

const getResourcesAsync = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, API_PATH.resources, undefined, undefined, false)
}

const getBenefitTypes = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, `${API_PATH.resources}${API_PATH.appraisal}${API_PATH.benefitTypes}`, undefined, undefined, false)
}

const createBenefitTypes = async (values: any): Promise<AxiosResponse> => {
    return await postAsync(serviceUrl, `${API_PATH.resources}${API_PATH.appraisal}${API_PATH.benefitTypes}`, values)
}

const inviteUser = async (values: InviteUserModel): Promise<AxiosResponse> => {
    return await postAsync(serviceUrl, `${API_PATH.inviteUser}`, values)
}

const updateUser = async (values: InviteUserModel): Promise<AxiosResponse> => {
    return await putAsync(serviceUrl, `${API_PATH.users}${values.username}/`, values)
}

const deleteUser = async (username: string): Promise<AxiosResponse> => {
    return await deleteAsync(serviceUrl, `${API_PATH.users}${username}/`)
}

const getUsers = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, `${API_PATH.users}`)
}

const generalOnboarding = async (values: AllOnboardingModel): Promise<AxiosResponse> => {
    return await postAsync(serviceUrl, `${API_PATH.generalOnboarding}`, values)
}

const downloadSampleConfigFile = async (type: string): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, `${API_PATH.downloadSampleConfigFile}/${type}`);
}

const uploadConfigFile = async (file_type: string, file: File): Promise<AxiosResponse> => {
    return await uploadFileAsync(serviceUrl, API_PATH.uploadConfigFile, { file_type, file });
}

const getConfigFiles = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, API_PATH.configFiles);
}

const getConfigFileDetail = async (file_type: string): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, `${API_PATH.configFiles}${file_type}`);
}

const deleteConfigFile = async (file_type: string): Promise<AxiosResponse> => {
    return await deleteAsync(serviceUrl, `${API_PATH.configFiles}${file_type}`);
}

const getClientInfo = async (): Promise<AxiosResponse> => {
    return await getAsync(serviceUrl, `${API_PATH.clientInfo}`);
}


export const ClientService = {
    getResourcesAsync,
    getBenefitTypes,
    createBenefitTypes,
    inviteUser,
    generalOnboarding,
    downloadSampleConfigFile,
    uploadConfigFile,
    getConfigFiles,
    updateUser,
    deleteUser,
    getUsers,
    getConfigFileDetail,
    deleteConfigFile,
    getClientInfo
};
